const sessionResultsPage = {
  "session-results.retry.waiting": "Esperando la repetición…",
  "session-results.retry.compare": "Comparar decisiones",
  "session-results.retry.original": "Antes",
  "session-results.retry.latest": "Después",
  "session-results.retry.evaluating": "Evaluando decisiones…",
  "session-results.retry.first-decision": "Primera decisión: {{original}} → {{retry}} / 100 ({{difference}} puntos)",
  "session-results.retry.action": "Intentar de nuevo",
  "session-results.retry.launching": "Iniciando escenario…",
  "session-results.retry.description": "Practica sin guardar una nueva sesión ni cambiar estos resultados.",
  "session-results.retry.unavailable": "Abre este escenario en la aplicación de entrenamiento para intentarlo de nuevo.",
  "session-results.retry.error": "No se pudo iniciar o analizar el intento. Puedes intentarlo de nuevo.",
  "session-results.title": "Resultados de la Sesión",
  "session-results.not-found": "Todavía estamos preparando esta sesión, ¡vuelve más tarde!",
  "session-results.section.results": "Resultados ({{ count }})",
  "session-results.section.feedback": "Retroalimentación",
  "session-results.section.metrics": "Sus métricas",
  "session-results.decision-insights": "Perspectivas sobre la decisión",
  "session-results.beta.learn-more": "Beta · Más información",
  "session-results.beta-dialog.title": "Una forma más inteligente de entender tus decisiones",
  "session-results.beta-dialog.p1":
    "Estás viendo nuestro nuevo modelo de decisión en beta, que te ofrece una visión más precisa de tus elecciones en el campo.",
  "session-results.beta-dialog.p2":
    "A medida que lo perfeccionamos, es posible que notes pequeñas diferencias respecto a tu puntuación habitual, pero eso forma parte de la mejora.",
  "session-results.beta-dialog.footer": "Eres de los primeros en probarlo!",

  "session-results.results.summary": "Resumen",
  "session-results.results.analysis": "Análisis",
  "session-results.results.overall-result": "Resultado General",
  "session-results.results.scenario-result-short": "E{{ index }}",
  "session-results.results.scenario-result": "Escenario {{ index }}",
  "session-results.results.pass-rating": "Calificación de Pase",
  "session-results.results.opportunity-rating": "Oportunidad",
  "session-results.results.decision-making": "Toma de Decisiones",
  "session-results.results.scan-frequency": "Frecuencia de Escaneo",
  "session-results.results.session-duration": "Duración de la Sesión",
  "session-results.results.scenarios-completed": "Escenarios Completados",
  "session-results.results.activities-completed": "Actividades Completadas",
  "session-results.results.performance-improvement": "Mejora de Rendimiento",
  "session-results.results.improvement": "Mejora",
  "session-results.results.decline": "Declive",
  "session-results.results.no-change": "Sin Cambio",
  "session-results.results.result": "Resultado {{ index }}",
  "session-results.results.decision-number": "{{ current }} de {{ total }}",

  "session-results.next-challenge": "Próximo Desafío",

  "session-results.bootcamp-complete.title": "Bootcamp completado",
  "session-results.bootcamp-complete.description":
    "Has desbloqueado la experiencia de entrenamiento completa. Estas son las métricas principales que usarás para mejorar tu juego.",
  "session-results.bootcamp-complete.continue": "Continuar al entrenamiento",

  "session-results.bootcamp.title": "¡Buen trabajo!",
  "session-results.bootcamp.failed.title": "¡Buen esfuerzo!",
  "session-results.bootcamp.failed.description": "No completaste esta sesión, pero cada intento ayuda. Revisa tu puntuación e inténtalo de nuevo.",
  "session-results.bootcamp.progress-count": "{{ current }} de 7 completado",
  "session-results.bootcamp.progress-label": "Progreso del Bootcamp",
  "session-results.bootcamp.continue": "Continuar Bootcamp",
  "session-results.bootcamp.continue-to-full-experience": "Continuar a la experiencia completa",
  "session-results.bootcamp.see-full-results": "Ver resultados completos",
  "session-results.bootcamp.play-again": "Jugar de nuevo",
  "session-results.bootcamp.final.description":
    "Has desbloqueado la experiencia de entrenamiento completa. Tu BYB IQ es la puntuación general que usarás para seguir tu progreso a partir de ahora.",
  "session-results.bootcamp.final.tip-body":
    "Abre tus resultados completos para revisar cada métrica y continúa con el entrenamiento para seguir mejorando.",
  "session-results.bootcamp.passing-basics.description": "Completaste los fundamentos de pase y construiste la base para las próximas sesiones.",
  "session-results.bootcamp.passing-basics.tip-body":
    "Busca pases progresivos que hagan avanzar a tu equipo. Si no hay un pase hacia adelante, mantener la posesión suele ser la mejor opción.",
  "session-results.bootcamp.decision-making.description":
    "Completaste el desafío de Toma de Decisiones. Tu puntuación refleja la calidad de la opción que elegiste.",
  "session-results.bootcamp.decision-making.tip-body":
    "Escanea para detectar espacios, presión, desmarques y oportunidades de gol antes de elegir la opción que genere más valor.",
  "session-results.bootcamp.scan-rate.description":
    "Completaste Frecuencia de Escaneo. Tu puntuación muestra con qué frecuencia apartaste la mirada del balón para observar tu entorno.",
  "session-results.bootcamp.scan-rate.tip-body":
    "Haz miradas rápidas y frecuentes a tu alrededor, volviendo la atención al balón entre cada escaneo.",
  "session-results.bootcamp.scan-timing.description":
    "Completaste Timing de Escaneo. Tu puntuación muestra con qué frecuencia escaneaste cuando era seguro apartar la mirada del balón.",
  "session-results.bootcamp.scan-timing.tip-body":
    "Escanea mientras el balón viaja o entre toques y vuelve a mirarlo antes de que el siguiente jugador haga contacto.",
  "session-results.bootcamp.awareness.description":
    "Completaste Percepción. Tu puntuación refleja con qué precisión recordaste a los jugadores que viste durante tus escaneos.",
  "session-results.bootcamp.awareness.tip-body":
    "En cada escaneo, fíjate dónde están los jugadores y a qué equipo pertenecen para recordar la imagen completa.",
  "session-results.bootcamp.critical-scan.description":
    "Completaste Escaneo Crítico. Tu puntuación muestra con qué frecuencia escaneaste mientras el balón viajaba hacia ti.",
  "session-results.bootcamp.critical-scan.tip-body":
    "Da una última mirada a tu alrededor después del pase y vuelve la atención al balón antes de recibirlo.",

  "session-result.title": "Resultado de la Sesión",
  "session-result.overview": "Resumen",

  "session-result.session-score": "Puntuación de la Sesión",

  "session-results.feedback.no-data": "No hay datos disponibles",
  "session-results.feedback.your-decision": "Su decisión",
  "session-results.feedback.your-decision-short": "Su decisión",
  "session-results.feedback.alternative-decision": "Decisión alt.",
  "session-results.feedback.alternative-decision-short": "Alt.",
  "session-results.feedback.no-decision": "Sin Decisión hecha",
  "session-results.feedback.opportunity": "Oportunidad",
  "session-results.feedback.safety": "Seguridad",

  "session-results.decision-filter.all": "Todas las decisiones",
  "session-results.decision-filter.shot": "Tiros",
  "session-results.decision-filter.ground": "Pases rasos",
  "session-results.decision-filter.through": "Pases filtrados",
  "session-results.decision-filter.loft": "Pases elevados",
  "session-results.decision-filter.cross": "Centros",
  "session-results.decision-filter.turnover": "Pérdidas",
  "session-results.decision-filter.no-results": "Ninguna decisión coincide con este filtro",

  "session-results.previous-decision": "Decisión Anterior",
  "session-results.next-decision": "Próxima Decisión",
  "session-results.decision-number": "Decisión {{ number }}",
  "session-results.decision-panel.title": "Puntuación de la decisión",
  "session-results.decision-panel.expected-goals": "Goles esperados",
  "session-results.decision-panel.expected-threat": "Amenaza esperada",
  "session-results.decision-panel.expected-pass": "Pase esperado",
  "session-results.decision-panel.expected-pass-turnover": "Pérdida por pase",
  "session-results.decision-panel.no-selection": "Elige una alternativa para ver el desglose de su puntuación.",
  "session-results.decision-panel.feedback.excellent": "Excelente elección. Esta opción lideró los resultados disponibles.",
  "session-results.decision-panel.feedback.great": "Muy buena decisión. Estuviste cerca de la mejor opción disponible.",
  "session-results.decision-panel.feedback.good": "Opción sólida. Aquí todavía había un pase mejor disponible.",
  "session-results.decision-panel.feedback.improve": "Había una decisión de mayor valor disponible en este momento.",
  "session-results.scores-dialog.title": "Entender las puntuaciones",
  "session-results.scores-dialog.subtitle": "Estas métricas ayudan a evaluar la calidad e impacto de tus decisiones.",
  "session-results.scores-dialog.xt.title": "Amenaza Esperada (xT)",
  "session-results.scores-dialog.xt.description": "Cuánto aumentan las acciones en una posición dada la probabilidad de marcar.",
  "session-results.scores-dialog.xp.title": "Pase Esperado (xP)",
  "session-results.scores-dialog.xp.description":
    "Probabilidad de que un pase llegue exitosamente a su objetivo previsto, basada en factores como presión, distancia, ángulo y orientación corporal.",
  "session-results.scores-dialog.xpt.title": "Pérdidas de Pase Esperadas (xPT)",
  "session-results.scores-dialog.xpt.description":
    "Probabilidad de que un pase resulte en una pérdida de posesión, intercepción, mal control o fuera de juego.",
  "session-results.scores-dialog.xg.title": "Goles Esperados (xG)",
  "session-results.scores-dialog.xg.description": "Probabilidad de que un disparo dado resulte en un gol.",
  "session-results.scores-dialog.how-it-works.title": "Cómo funciona",
  "session-results.scores-dialog.how-it-works.description":
    "El motor utiliza un modelo de Valor Q Ajustado al Riesgo. Cada pase se evalúa por su beneficio esperado (recompensa) ponderado por la probabilidad de completarlo, menos el coste ponderado de una pérdida en esa ubicación específica.",
  "session-results.scores-dialog.how-it-works.formula": "Q_{pass} = \\text{Reward}_{adj} \\cdot P_{comp} - \\text{Penalty}_{adj} \\cdot xPT",
  "session-results.scores-dialog.how-it-works.sub-formula": "P_{comp} = (1 - xPT) \\cdot xP \\quad | \\quad \\text{Reward} = \\max(xG, xT)",
  "session-results.scores-dialog.how-it-works.overall-score":
    "En términos sencillos, calculamos tu impacto neto: el valor de ataque generado menos el riesgo de una intercepción. Este resultado se compara luego con el pase óptimo para generar tu puntuación de 0-100. Una puntuación de 100 significa que encontraste la mejor opción matemática para un escenario determinado.",

  "session-results.video.2d": "2D",
  "session-results.video.3d": "3D",
  "session-results.video.vision-cone": "Cono de Visión",
  "session-results.video.heatmap": "Mapa de Calor",
  "session-results.video.time-display": "{{ currentTime }} / {{ duration }}",

  "session-results.scenario.replay": "Repetir Escenario",
  "session-results.replay.error.title": "No se pudo cargar la repetición",
  "session-results.replay.error.message": "Inténtalo de nuevo más tarde.",
  "session-results.filter-by.results": "Filtrar por resultados",

  "session-results.training-stats.title": "Estadísticas de Entrenamiento",
  "session-results.training-stats.scenarios": "Escenarios",
  "session-results.training-stats.total-duration": "Duración Total",
  "session-results.training-stats.date": "Fecha",
  "session-results.training-stats.session-type": "Tipo de Sesión",

  "session-results.scan-rate-maxed.pill": "Puntuación máxima",
  "session-results.scan-rate-maxed.title": "¡Máxima eficiencia alcanzada!",
  "session-results.scan-rate-maxed.intro":
    "¡Buen trabajo! Has alcanzado el máximo de puntos de frecuencia de escaneo hacia tu BYB IQ. Tu puntuación bruta exacta sigue mostrándose a continuación, pero el cálculo se limita a {{maxScanRate}} escaneos por segundo.",
  "session-results.scan-rate-maxed.why.title": "¿Por qué el límite?",
  "session-results.scan-rate-maxed.why.body":
    "Profesionales de élite como Xavi alcanzan un máximo de 0,83 escaneos/seg con una eficiencia excepcional. Con {{maxScanRate}} o más, ya has dominado la frecuencia de clase mundial para escanear entre toques y seguir el campo.",
  "session-results.scan-rate-maxed.whats-next.title": "¿Qué sigue?",
  "session-results.scan-rate-maxed.whats-next.body":
    "Ahora que tu velocidad de escaneo es de clase mundial, la clave para impulsar tu BYB IQ general es llevar tus otras puntuaciones cognitivas al mismo nivel de élite. ¡Vamos!",
};

const motivators = {
  "session-result.outcome.bootcamp.excellent-1": "¡Excelente!",
  "session-result.outcome.bootcamp.excellent-1-subtitle": "Un rendimiento espléndido.",

  "session-result.outcome.bootcamp.excellent-2": "¡Increíble!",
  "session-result.outcome.bootcamp.excellent-2-subtitle": "",

  "session-result.outcome.bootcamp.great-1": "¡Gran trabajo!",
  "session-result.outcome.bootcamp.great-1-subtitle": "Una sesión bien ejecutada.",

  "session-result.outcome.bootcamp.great-2": "¡Bien hecho!",
  "session-result.outcome.bootcamp.great-2-subtitle": "Una excelente sesión.",

  "session-result.outcome.bootcamp.good-1": "¡Buen trabajo!",
  "session-result.outcome.bootcamp.good-1-subtitle": "Completaste los objetivos con un margen cómodo.",

  "session-result.outcome.bootcamp.good-2": "¡Bien hecho!",
  "session-result.outcome.bootcamp.good-2-subtitle": "Una sesión sólida.",

  "session-result.outcome.bootcamp.average-1": "¡Bien!",
  "session-result.outcome.bootcamp.average-1-subtitle": "Completaste tus objetivos.",

  "session-result.outcome.bootcamp.average-2": "Bien hecho.",
  "session-result.outcome.bootcamp.average-2-subtitle": "Avanzando a la siguiente división.",

  "session-result.outcome.bootcamp.below_average-1": "¡Casi allí!",
  "session-result.outcome.bootcamp.below_average-1-subtitle": "Intenta nuevamente.",

  "session-result.outcome.bootcamp.below_average-2": "¡Casi lo logras!",
  "session-result.outcome.bootcamp.below_average-2-subtitle": "",

  "session-result.outcome.bootcamp.poor-1": "No llegaste.",
  "session-result.outcome.bootcamp.poor-1-subtitle": "Intenta nuevamente para alcanzar tus objetivos.",

  "session-result.outcome.bootcamp.poor-2": "Hay espacio para mejorar",
  "session-result.outcome.bootcamp.poor-2-subtitle": "Intenta nuevamente para alcanzar tus objetivos.",

  "session-result.outcome.excellent-1": "¡Trabajo sobresaliente!",
  "session-result.outcome.excellent-1-subtitle": "Tu arduo trabajo está dando frutos.",

  "session-result.outcome.excellent-2": "¡Rendimiento excepcional!",
  "session-result.outcome.excellent-2-subtitle": "",

  "session-result.outcome.excellent-3": "¡Increíble! ",
  "session-result.outcome.excellent-3-subtitle": "¡Está claro que tu esfuerzo está marcando la diferencia!",

  "session-result.outcome.great-1": "¡Gran trabajo!",
  "session-result.outcome.great-1-subtitle": "Superaste los objetivos con márgenes impresionantes.",

  "session-result.outcome.great-2": "¡Buen trabajo!",
  "session-result.outcome.great-2-subtitle": "Tu esfuerzo fue significativamente superior al promedio, ¡sigue así!",

  "session-result.outcome.great-3": "¡Una gran sesión!",
  "session-result.outcome.great-3-subtitle": "",

  "session-result.outcome.good-1": "¡Buen trabajo!",
  "session-result.outcome.good-1-subtitle": "Sigue rindiendo a este nivel para avanzar más.",

  "session-result.outcome.good-2": "Una sesión sólida.",
  "session-result.outcome.good-2-subtitle": "",

  "session-result.outcome.good-3": "¡Bien hecho!",
  "session-result.outcome.good-3-subtitle": "Una buena sesión.",

  "session-result.outcome.average-1": "¡Buen trabajo! ",
  "session-result.outcome.average-1-subtitle": "Ligeramente por encima del objetivo de la sesión.",

  "session-result.outcome.average-2": "Bien hecho.",
  "session-result.outcome.average-2-subtitle": "Lograste alcanzar el objetivo de la sesión.",

  "session-result.outcome.average-3": "Objetivos alcanzados",
  "session-result.outcome.average-3-subtitle": "",

  "session-result.outcome.below_average-1": "Casi, pero no lo lograste.",
  "session-result.outcome.below_average-1-subtitle": "Sigue esforzándote para superar el objetivo.",

  "session-result.outcome.below_average-2": "Casi lo alcanzaste.",
  "session-result.outcome.below_average-2-subtitle": "¡Sigue intentándolo!",

  "session-result.outcome.below_average-3": "¡Estás cerca!",
  "session-result.outcome.below_average-3-subtitle": "¡Inténtalo otra vez!",

  "session-result.outcome.poor-1": "Una sesión difícil.",
  "session-result.outcome.poor-1-subtitle": "Vuelve a lo básico e inténtalo de nuevo.",

  "session-result.outcome.poor-2": "No fue tu mejor rendimiento.",
  "session-result.outcome.poor-2-subtitle": "",

  "session-result.outcome.poor-3": "No alcanzaste el objetivo.",
  "session-result.outcome.poor-3-subtitle": "¡Intenta nuevamente!",
};

export const sessionResults = {
  ...sessionResultsPage,
  ...motivators,
};
